var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomAttributeBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.073,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z",
    style: {
      stroke: "#707070",
      fill: "#185edf"
    },
    transform: "translate(1301 146)"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".d{fill:#185edf}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    },
    transform: "translate(-1301 -146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z",
    style: {
      fill: "none"
    },
    transform: "translate(1301 146)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1321.938 161.208 2.865-.781a11.979 11.979 0 0 0 0-3.854l-2.865-.781a.937.937 0 0 1-.573-1.354l1.458-2.6a10.729 10.729 0 0 0-2.656-2.656l-2.6 1.458-.417.1a.938.938 0 0 1-.937-.677l-.786-2.863a11.979 11.979 0 0 0-3.854 0l-.781 2.863a.937.937 0 0 1-.937.677l-.417-.1-2.6-1.458a10.729 10.729 0 0 0-2.661 2.651l1.458 2.6a.938.938 0 0 1-.573 1.354l-2.862.786a11.979 11.979 0 0 0 0 3.854l2.865.781a.938.938 0 0 1 .573 1.354l-1.458 2.6a10.729 10.729 0 0 0 2.656 2.656l2.6-1.458.417-.1a.938.938 0 0 1 .938.677l.781 2.865a11.979 11.979 0 0 0 3.854 0l.781-2.865a.938.938 0 0 1 .938-.677l.417.1 2.6 1.458a10.729 10.729 0 0 0 2.656-2.656l-1.458-2.6a.937.937 0 0 1 .573-1.354zm-.625-2.031h-.1a3.177 3.177 0 0 0-1.776 1.723 2.969 2.969 0 0 0 .052 2.5h.052v.1l.781 1.3a1.562 1.562 0 0 1-.417.417l-1.3-.781h-.156a2.812 2.812 0 0 0-1.3-.312 3.125 3.125 0 0 0-2.917 2.031v.156l-.469 1.563h-.523l-.417-1.51v-.1a3.125 3.125 0 0 0-2.969-2.083 2.812 2.812 0 0 0-1.3.312h-.154l-1.3.781a1.562 1.562 0 0 1-.417-.417l.781-1.3v-.1h.046a2.969 2.969 0 0 0 .052-2.5 3.177 3.177 0 0 0-1.771-1.719h-.156l-1.51-.469v-.529l1.51-.417h.156a3.177 3.177 0 0 0 1.772-1.723 2.969 2.969 0 0 0-.053-2.5h-.052v-.1l-.781-1.3.417-.417 1.3.781h.156a2.813 2.813 0 0 0 1.3.313 3.125 3.125 0 0 0 2.917-2.031v-.158l.469-1.562h.521l.417 1.51v.1a3.125 3.125 0 0 0 2.969 2.083 2.813 2.813 0 0 0 1.3-.312h.157l1.3-.781a1.563 1.563 0 0 1 .417.417l-.781 1.3v.1h-.046a2.969 2.969 0 0 0-.052 2.5 3.177 3.177 0 0 0 1.771 1.719h.156l1.51.417v.521l-1.51.417z",
    className: "d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.5 153.812a4.688 4.688 0 1 0 4.688 4.688 4.688 4.688 0 0 0-4.688-4.688zm0 7.292a2.6 2.6 0 1 1 2.6-2.6 2.6 2.6 0 0 1-2.6 2.596z",
    className: "d"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.003 23.127v-3.514h14.07v3.518zm0-7.036 14.07-3.519h-3.518v3.518zm0-7.036 10.552-3.519h7.036v3.518z",
    className: "d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAttributeBlue);
export default __webpack_public_path__ + "static/media/Custom_Attribute-blue.6ed47708c6323ab77fd827d34011e9ad.svg";
export { ForwardRef as ReactComponent };